import $ from 'jquery';

$.addInit(function(context) {
	var base = '.b-select';

	$.fn.select2.amd.require([
		'select2/utils',
		'select2/dropdown',
		'select2/dropdown/attachContainer',
		'select2/dropdown/search',
		'select2/dropdown/closeOnSelect',
		'select2/selection/placeholder'
	] , function (Utils, DropdownAdapter, AttachContainer, DropdownSearch, closeOnSelect, Placeholder ) {

		$(base, context).each(function(){
			var component = $(this);
			var select = component.find('select');

			select.select2({
				width: "100%",
				dropdownParent: component,
				dropdownAdapter: Utils.Decorate(Utils.Decorate(DropdownAdapter, AttachContainer), closeOnSelect),
				closeOnSelect: true,
			});
		});
	});
});
